<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="6" :sm="24">
            <a-form-item label="Query">
              <a-input v-model="queryParam.name" placeholder="Name / Number" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item
              label="DOB"
              :validateStatus="birthdayValid.status"
              :help="birthdayValid.help"
            >
              <a-input
                v-model="queryParam.birthday"
                placeholder="mm/dd/yyyy"
                :maxLength="10"
                @change="handleDateChange"
                @blur="handleCustomerBirthdayBlur"
                @keyup.enter.stop="refreshCurrentPage"
              />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="Gender">
              <a-select v-model="queryParam.gender" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="M">Male</a-select-option>
                <a-select-option value="F">Female</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Company">
              <a-select v-model="queryParam.companyCode" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option v-for="i in companyList" :key="'company-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 4 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="reset">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('CDB_CUSTOMER_ADD')">New</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1100 }"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="joinTourTotal" slot-scope="text, record">
        <span>{{ record.joinTourTotal}}/{{ record.joinTourCancelTotal}}</span>
      </span>
      <div slot="writeDate" slot-scope="text, record" style="display: flex;">
        <div style="font-weight:500;margin-right: 6px;">{{ record.changeBy.userName }}</div>
        <div style="width: 80px;">{{ DateTimeUtil().localString(record.writeDate !== null ? record.writeDate : record.createDate) }}</div>
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)" :disabled="!$auth('CDB_CUSTOMER_EDIT')">Edit</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="Are you sure delete?"
            @confirm="onDeleteConfirmed(record)"
            okText="Yes"
            cancelText="No"
          >
            <a :disabled="!$auth('CDB_CUSTOMER_DELETE')">Delete</a>
          </a-popconfirm>
          <a-divider type="vertical" />
        </template>
        <a-dropdown>
          <a class="ant-dropdown-link"><a-icon type="down" /></a>
          <a-menu slot="overlay">
            <a-menu-item>
              <!-- :disabled="record.joinTourTotal === 0 && record.joinTourCancelTotal === 0" -->
              <a href="javascript:;"><a @click="showMergeToModal(record)">Merge To</a></a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <a-modal
      title="Merge Join Tour Record To Other Customer"
      :visible="mergeToRecord !== null"
      :confirm-loading="mergeToLoading"
      @ok="handleMergeToConfirm"
      @cancel="handleMergeToCancel"
    >
      <a-form-model
        ref="mergeToForm"
        :model="mergeToForm"
        :rules="mergeToRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="Customer code" prop="targetCustomerCode">
          <a-input placeholder="Customer Number" v-model="mergeToForm.targetCustomerCode"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import CDBApi from '@/api/api-cdb-customer'
import { Company } from '@/utils/helper/standard-code-utils'

export default {
  name: 'CdbCustomerList',
  components: {
    STable
  },
  data () {
    return {
      companyList: Company.dict,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { name: '', gender: '', companyCode: '', birthday: null },
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '50px',
          fixed: 'left'
        },
        {
          title: 'Number',
          dataIndex: 'customerCode',
          align:'center',
          width: '120px',
          fixed: 'left'
        },
        {
          title: 'Name',
          dataIndex: 'fullName'
        },
        {
          title: 'Gender',
          dataIndex: 'gender',
          align:'center',
          width: '80px',
          customRender: (value) => (value === 'M') ? 'Male' : 'Female'
        },
        {
          title: 'DOB',
          dataIndex: 'birthday',
          width: '120px',
          align:'center',
          customRender: (value) => this.dateFormatB(value)
        },
        {
          title: 'Join',
          dataIndex: 'joinTourTotal',
          align: 'center',
          width: '70px',
          scopedSlots: { customRender: 'joinTourTotal' }
        },
        {
          title: 'Company',
          dataIndex: 'companyCode',
          width: '100px',
          align:'center'
        },
        {
          title: 'Last Modified',
          dataIndex: 'writeDate',
          scopedSlots: { customRender: 'writeDate' }
        },
        {
          title: 'Action',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          align:'center',
          fixed: 'right'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        const queryParam = Object.assign({}, this.queryParam)
        if (queryParam.birthday) {
          queryParam.birthday = moment(queryParam.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD')
        } else {
          delete queryParam.birthday
        }
        return CDBApi.query(Object.assign(parameter, queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      // 合并团操作
      labelCol: { span: 7 },
      wrapperCol: { span: 12 },
      mergeToRecord: null,
      mergeToLoading: false,
      mergeToForm: { targetCustomerCode: null },
      mergeToRules: {
        targetCustomerCode: [{ required: true, message: 'Please input target customer code.' }],
      },
      // 客人生日是否有效,客人生日格式错误提示语
      birthdayValid: {
        status: 'success',
        help: ''
			}
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      CDBApi.delete(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Delete successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    // 合并出团次数
    showMergeToModal (record) {
      this.mergeToRecord = record
      this.mergeToForm = { targetCustomerCode: null }
    },
    handleMergeToConfirm () {
      this.$refs.mergeToForm.validate(async (valid) => {
        if (valid) {
          this.mergeToLoading = true
          try {
            const res = await CDBApi.mergeJoinToOtherCustomer(this.mergeToRecord.id, this.mergeToForm.targetCustomerCode)
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Merge successfully !')
              this.refreshCurrentPage()
              this.handleMergeToCancel()
            }
            this.mergeToLoading = false
          } catch (e) {
            this.mergeToLoading = false
            if (e && e.response && e.response.data) {
              this.$notification['error']({
                message: 'Error',
                description: `${e.response.data.errorMessage}`
              })
            }
          }
        }
      })
    },
    handleDateChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/([^0-9|\\/])/, '')
        if (/^[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        if (/^[0-9]{2}\/[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        e.target.value = newValue
        this.queryParam.birthday = newValue
        this.$nextTick(() => {
          if (newValue.length === 10) {
            this.handleCustomerBirthdayBlur()
          }
        })
      }
    },
    handleCustomerBirthdayBlur () {
      const value = this.queryParam.birthday
      // 日期格式
      const DATE_REG = /^(((0?[13578]|1[02])\/(0?[1-9]|[12]\d|3[01])\/((1[6-9]|[2-9]\d)\d{2}))|((0?[13456789]|1[012])\/(0?[1-9]|[12]\d|30)\/((1[6-9]|[2-9]\d)\d{2}))|(0?2\/(0?[1-9]|1\d|2[0-8])\/((1[6-9]|[2-9]\d)\d{2}))|(0?2\/29\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/
      let valid = false
      if (!value || value.length === 0) {
        this.birthdayValid.status = 'success'
        this.birthdayValid.help = ''	
        valid = false
      } else {
        if (DATE_REG.test(value)) {
          this.birthdayValid.status = 'success'
          this.birthdayValid.help = ''
          valid = true
        } else {
          this.birthdayValid.status = 'error'
          this.birthdayValid.help = 'Invalid date format!',
          valid = false
        }
      }
      return valid
    },
    handleMergeToCancel () {
      this.mergeToRecord = null
      this.mergeToForm = { targetCustomerCode: null }
    },
    //
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh()
    },
    // 重置查询条件
    reset () {
      this.queryParam = { name: '', gender: '', companyCode: '', birthday: null }
      this.refreshCurrentPage()
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
  padding: 14px;
}
</style>